// External deps

import { Route, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

// Internal deps
import { checkUserPermission } from '../../security/index';
import { MYROLS } from '../../services/yclickMaster';

const PermissionsRoute = ({ children, permission, exact, path }) => {
  const canView = permission.length ? checkUserPermission(permission) : true;
  const hasRoles = sessionStorage.getItem(MYROLS);
  const history = useHistory();

  // Puede suceder que el usuario no tenga roles asociados
  if (!hasRoles) {
    return null;
  }

  if (!canView) {
    return history.goBack();
  }

  return (
    <Route exact={exact} path={path}>
      {children}
    </Route>
  );
};

PermissionsRoute.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  path: PropTypes.string.isRequired,
  permission: PropTypes.arrayOf(PropTypes.string),
  exact: PropTypes.bool
};

PermissionsRoute.defaultProps = {
  permission: [],
  exact: false
};

export default PermissionsRoute;
